<template>
    <div>
        <span v-if="displayType">{{ displayType }}</span>
        <span v-else>-</span>
    </div>
</template>

<script>
export default {
    name: 'TypeColumn',
    props: {
        row: {
            type: Object,
            required: true
        },
        typeField: {
            type: String,
            default: 'type'
        },
        fallbackField: {
            type: String,
            default: 'type_name'
        }
    },
    computed: {
        displayType() {
            // Try primary field first, then fallback
            return this.row[this.typeField] || this.row[this.fallbackField]
        }
    }
}
</script>
